import React from "react";
import "./XeroxHeader.css";
import RmailLogo from "../../../../src/assets/images/x-logo22.png";

const XeroxHeader = function(prop) {
  return (
    <header>
      <nav className="RobotoFont navbar navbar-expand-lg navbar-dark fixed-top bg-them">
        <div className="container-fluid">
          <div className="navbar-brand xerox-brand">
            <img src={RmailLogo} alt="" height="20px" />
          </div>
          {/* <button
            className="RobotoFont navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button> */}
           <div
            className="RobotoFont collapse navbar-collapse d-sm-none d-lg-block"
            id="navbarCollapse"
           > 
            <ul className="navbar-nav me-auto mb-2 mb-md-0">
              <li className="nav-item">
                <div
                  className="nav-link active mt-3 mt-md-0"
                  aria-current="page"
                  style={{ fontSize: "22px" }}
                >
                  {prop.Reader_ProtectedDocument}
                </div>
              </li>
            </ul>
          </div>
          <div
            className="RobotoFont d-sm-block d-md-block d-lg-none"
           > 
            < ul className="navbar-nav me-auto mb-md-0">
              <li className="nav-item">
                <div
                  className="nav-link active "
                  aria-current="page"
                  style={{ fontSize: "20px" }}
                >
                  {prop.Reader_ProtectedDocument}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};
export default XeroxHeader;
